/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";
export type infoCreateOrUpdateVinDetailInput = {
    clientMutationId?: string | null;
    shipmentSlug: string;
    year?: string | null;
    model?: string | null;
    body?: string | null;
    engine?: string | null;
    country?: string | null;
    countryCode?: string | null;
    capacity?: string | null;
    fuelType?: string | null;
};
export type VinDetailsCardEditDialogMutationVariables = {
    input: infoCreateOrUpdateVinDetailInput;
};
export type VinDetailsCardEditDialogMutationResponse = {
    readonly infoCreateOrUpdateVinDetail: {
        readonly clientMutationId: string | null;
    } | null;
};
export type VinDetailsCardEditDialogMutation = {
    readonly response: VinDetailsCardEditDialogMutationResponse;
    readonly variables: VinDetailsCardEditDialogMutationVariables;
};



/*
mutation VinDetailsCardEditDialogMutation(
  $input: infoCreateOrUpdateVinDetailInput!
) {
  infoCreateOrUpdateVinDetail(input: $input) {
    clientMutationId
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "infoCreateOrUpdateVinDetailPayload",
    "kind": "LinkedField",
    "name": "infoCreateOrUpdateVinDetail",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "clientMutationId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "VinDetailsCardEditDialogMutation",
    "selections": (v1/*: any*/),
    "type": "ApplicationCommand",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "VinDetailsCardEditDialogMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "09b8a7a82905a333b5bbfc2098fb5b3a",
    "id": null,
    "metadata": {},
    "name": "VinDetailsCardEditDialogMutation",
    "operationKind": "mutation",
    "text": "mutation VinDetailsCardEditDialogMutation(\n  $input: infoCreateOrUpdateVinDetailInput!\n) {\n  infoCreateOrUpdateVinDetail(input: $input) {\n    clientMutationId\n  }\n}\n"
  }
};
})();
(node as any).hash = '95be82564a12092e31c4c5d72f730583';
export default node;
